enum AccountDetailsCreditClassification {
  FIXED = 'FIXED',
  DECREASING = 'DECREASING',
}

export default AccountDetailsCreditClassification;
